import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Timestamp } from '@angular/fire/firestore';

export const toDate = (dateField: any): Date => {
  let date = dateField;

  if (typeof dateField === 'string') {
    date = moment(dateField).toDate();
  } else if (dateField instanceof Timestamp) {
    date = dateField.toDate();
  } else if (dateField?._seconds) {
    date = moment.unix(dateField._seconds).toDate();
  } else if (dateField?.seconds) {
    date = moment.unix(dateField.seconds).toDate();
  }

  return date;
};

@Pipe({
  name: 'toDate',
  standalone: true,
})
export class ToDatePipe implements PipeTransform {
  transform(value: any, args?: any): Date {
    return toDate(value);
  }
}
